import { useCallback } from 'react';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { useFinalizeStepTrackingCallbacks, useInitiateStepTracking } from '../../../../utils/step-tracking-store';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import { ManualCardEntryStepNavigationProps } from '../manual-card-entry.types';

export const ManualCardEntryGenericNavigation = ({ body: Body }: ManualCardEntryStepNavigationProps) => {
  const {
    onPaymentSuccess: onPaymentSuccessContext,
    multiStep: { goPrevStep, onComplete },
    activeGateway,
    flow,
  } = useCollectPaymentMultiContext();

  const { completeStepTracking, cancelStepTracking } = useFinalizeStepTrackingCallbacks({
    step: 'manual-card-entry',
    variant: 'default',
  });

  const onGoBack = useCallback(() => {
    goPrevStep({ orStep: PAYMENT_MULTI_STEPS.paymentMethods });
    cancelStepTracking();
  }, [cancelStepTracking, goPrevStep]);

  const onPaymentSuccess = useCallback(() => {
    onPaymentSuccessContext?.();
  }, [onPaymentSuccessContext]);

  const onCompleteStep = useCallback(() => {
    onComplete();
    completeStepTracking();
  }, [onComplete, completeStepTracking]);

  useInitiateStepTracking({
    activeGateway,
    flow,
    step: 'manual-card-entry',
    screenWidth: window.innerWidth,
    variant: 'default',
  });

  return <Body onGoBack={onGoBack} onPaymentSuccess={onPaymentSuccess} onCompleteStep={onCompleteStep} />;
};
